"use strict";
/*
 * Copyright 2023 The NATS Authors
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamImpl = exports.StreamsImpl = void 0;
const jsmconsumer_api_1 = require("./jsmconsumer_api");
const consumers_1 = require("./consumers");
class StreamsImpl {
    constructor(api) {
        this.api = api;
    }
    get(stream) {
        return this.api.info(stream)
            .then((si) => {
            return new StreamImpl(this.api, si);
        });
    }
}
exports.StreamsImpl = StreamsImpl;
class StreamImpl {
    constructor(api, info) {
        this.api = api;
        this._info = info;
    }
    get name() {
        return this._info.config.name;
    }
    alternates() {
        return this.info()
            .then((si) => {
            return si.alternates ? si.alternates : [];
        });
    }
    best() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.info();
            if (this._info.alternates) {
                const asi = yield this.api.info(this._info.alternates[0].name);
                return new StreamImpl(this.api, asi);
            }
            else {
                return this;
            }
        });
    }
    info(cached = false) {
        if (cached) {
            return Promise.resolve(this._info);
        }
        return this.api.info(this.name)
            .then((si) => {
            this._info = si;
            return this._info;
        });
    }
    getConsumer(name) {
        return new consumers_1.ConsumersImpl(new jsmconsumer_api_1.ConsumerAPIImpl(this.api.nc, this.api.opts))
            .get(this.name, name);
    }
    getMessage(query) {
        return this.api.getMessage(this.name, query);
    }
}
exports.StreamImpl = StreamImpl;
//# sourceMappingURL=stream.js.map